import { Request } from '../../../../generic/v2/request/request';
import { EventRequestRequestNameType } from '../../../event-request-name';

export abstract class EventRequest extends Request<EventRequestRequestNameType> {}
